module.exports = __webpack_public_path__ + "static/img_1667-f079c8dbf39d38f52989c7aa75f99594.webp";